module.exports = __webpack_public_path__ + "logo-magento.d3243911180d8902e0e9a6f5dc1fc4bd.svg";